const slider_partners = $('.slider-partners');

if (slider_partners.length) {
    slider_partners.liMarquee({
        scrollStop: false,
        circular: true,
        startShow: true,
        hoverStop: false,
        dragAndDrop: false
    });
}

$(".widgets-collapse .collapse-head:not(.-single)").on("click", function (e) {
    const $this = $(this);
    const $collapseHead = $(".widgets-collapse .collapse-head");
    const $collapseContent = $(".widgets-collapse .collapse-content");

    if (!$this.hasClass("-active")) {
        $collapseHead.removeClass("-active");
        $collapseContent.slideUp();
        $this.addClass("-active");
        $this.closest('.widget').find('.collapse-content').slideDown();
    } else {
        $collapseHead.removeClass("-active");
        $collapseContent.slideUp();
    }
});